import { auth } from '../firebase';

/** Slow networks / cold Firebase can exceed 15s; modal + membership rely on this budget. */
const GET_ID_TOKEN_MS = 22000;

function withTimeout(promise, ms, label) {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => {
        const err = new Error(`${label} timed out after ${ms}ms`);
        err.name = 'AuthTokenTimeoutError';
        reject(err);
      }, ms);
    }),
  ]);
}

/**
 * Fetch wrapper that automatically attaches Firebase ID token (if available).
 * Retries once on 401 with a fresh token to handle timing after auth state change.
 * getIdToken is bounded so the request can still abort if auth stalls (otherwise busy UI hangs forever).
 */
async function authFetchOnce(url, options, forceRefresh = false) {
  let token = null;
  if (auth.currentUser?.getIdToken) {
    token = await withTimeout(auth.currentUser.getIdToken(forceRefresh), GET_ID_TOKEN_MS, 'getIdToken');
  }
  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers });
}

export async function authFetch(url, options = {}) {
  let res = await authFetchOnce(url, options, false);
  if (res.status === 401 && auth.currentUser) {
    res = await authFetchOnce(url, options, true);
  }
  return res;
}

